module.exports = __webpack_public_path__ + "img/deep-soil.dba283fe.svg";